import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import KeyBoard from '../../items/keyboard';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import { useHistory } from 'react-router';

export default function HelloRegister(props) {
  let history = useHistory();
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const [pd, setPd] = useState('');

  const [showKeyboard, setShowKeyboard] = useState(false);
  const [showKeyboard2, setShowKeyboard2] = useState(false);

  const { t } = useTranslation();
  const keyboard = useRef();
  const keyboard2 = useRef();
  const { show, onHide } = props;

  const emailPattern = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$');

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    // keyboard.current.setInput(input);
  };

  const onChangePd = (event) => {
    const input = event.target.value;
    setPd(input);
    // keyboard.current.setInput(input);
  };

  useEffect(() => {
    // console.log(props.cart);
    if (input === '') {
      setError('');
    } else if (emailPattern.test(input)) {
      setError('');
    } else {
      setError(t('Please enter valid email address.'));
    }
    return () => {
      setError('');
    };
  }, [input]);

  useEffect(() => {
    setTimeout(() => {
      setShowKeyboard(show);
    }, 400);
    setInput('');
    setPd('');
    setError('');
    return () => {
      setShowKeyboard(false);
    };
  }, [show]);

  const onSubmit = async (e) => {
    const referTo = JSON.parse(localStorage.getItem('machine')).belongTo;
    if (error || !input) {
      return Swal.fire({
        icon: 'error',
        title: 'Registratoin failed!',
        html: error || 'Please enter email address.',
        allowOutsideClick: false,
      });
    } else {
      request({
        method: 'POST',
        url: '/users/alph/register',
        data: {
          referTo: referTo,
          email: input,
        },
      })
        .then((res) => {
          Swal.fire({
            icon: 'success',
            title: 'Registratoin succeded!',
            html: 'We are sending you an email with the pin.',
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          }).then(() => {
            onHide();
            const gethomepage = localStorage.getItem('homepage');
            history.push(gethomepage);
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Registratoin failed!',
            html: error?.response?.data?.message,
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.hideLoading();
            },
          });
        });

      // request({
      //   method: 'POST',
      //   url: '/users/hf/register',
      //   data: {
      //     email: input,
      //   },
      // })
      //   .then((res) => {
      //     Swal.fire({
      //       icon: 'success',
      //       title: 'Registratoin succeded!',
      //       html: 'We are sending you an email with a QR code.',
      //       allowOutsideClick: false,
      //       onBeforeOpen: () => {
      //         Swal.showLoading();
      //       },
      //     }).then(() => {
      //       onHide();
      //     });
      //   })
      //   .catch((error) => {
      //     Swal.fire({
      //       icon: 'error',
      //       title: 'Registratoin failed!',
      //       html: error?.response?.data?.message,
      //       allowOutsideClick: false,
      //       onBeforeOpen: () => {
      //         Swal.hideLoading();
      //       },
      //     });
      //   });
      //assuce login
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body
        className="promo-modal"
        style={{
          width: '90%',
          margin: 'auto',
        }}
      >
        <div
          id="close_promo_modal"
          onClick={() => {
            props.onHide();
          }}
        ></div>
        <Container>
          <div
            className="d-flex flex-column align-items-center justify-content-center mt-4 pb-4"
            style={{ textAlign: 'center', padding: '0px 20px' }}
          >
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '80px',
              }}
              className="themeColor"
            >
              {t(`Welcome!`)}
            </div>
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '30px',
                marginBottom: '30px',
                padding: '0px 30px',
              }}
            >
              {t(
                `Please register by entering your email address below. If you already registered, please enter your ping.`
              )}
            </div>
            <input
              id="email-enter-input"
              type="email"
              placeholder={t(`Email address`)}
              value={input}
              // onClick={handleShow}
              onChange={onChangeInput}
              aria-label="Search"
              className="promo-input themeColor"
              style={{
                borderWidth: '4px',
                height: '60px',
              }}
            />

            <input
              id="email-enter-input"
              type="password"
              placeholder={t(`Password`)}
              value={pd}
              // onClick={handleShow}
              onChange={onChangePd}
              aria-label="Search"
              className="promo-input themeColor mt-4"
              style={{
                borderWidth: '4px',
                height: '60px',
              }}
            />

            <KeyBoard
              show={showKeyboard}
              setShow={setShowKeyboard}
              handleClick={onSubmit}
              send={true}
              // handleClose={onHide()}
              input={input}
              setInput={setInput}
              keyboard={keyboard}
            />

            <KeyBoard
              show={showKeyboard2}
              setShow={setShowKeyboard2}
              handleClick={onSubmit}
              send={true}
              // handleClose={onHide()}
              input={pd}
              setInput={setPd}
              keyboard={keyboard2}
            />

            {error && (
              <div className="cart-checkout-error mt-2" style={{ color: 'red' }}>
                {error}
              </div>
            )}

            <div className="hf-regi-button mb-4" onClick={onSubmit}>
              Register
            </div>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
